
import {
  EventTakeoverVisual,
  EVENT_TAKEOVER_BACKGROUND_TYPE,
} from "@app/views/Home/types";
import { Vue, Component, Prop } from "vue-property-decorator";
import { SmartImageProps } from "_components";
import Gallery from "./Gallery.vue";

@Component({
  name: "EventTakeoverBackground",
  components: { Gallery },
})
export default class EventTakeoverBackground extends Vue {
  rootClass = "p-event-background";
  @Prop() data: EventTakeoverVisual;
  @Prop() isMob: boolean;

  handleLoad() {
    this.$emit("loaded");
  }

  get isImage() {
    return this.data.background.type === EVENT_TAKEOVER_BACKGROUND_TYPE.IMAGE;
  }

  get isVideo() {
    return this.data.background.type === EVENT_TAKEOVER_BACKGROUND_TYPE.VIDEO;
  }

  get images(): SmartImageProps[] {
    if (!this.isImage || !this.data) return [];
    const src =
      this.isMob && this.data.background.images_mobile
        ? this.data.background.images_mobile
        : this.data.background.images;
    return src
      ? src.map((image) => ({
          image,
          lazyload: false,
          fit: "cover",
        }))
      : [];
  }

  get displacementImage(): SmartImageProps {
    if (!this.isImage || !this.data) return null;
    const image =
      this.isMob && this.data.background.displacement_mobile
        ? this.data.background.displacement_mobile
        : this.data.background.displacement;
    return (
      image && {
        image,
        lazyload: false,
        fit: "cover",
      }
    );
  }

  get video() {
    return this.data && this.isVideo && this.data.background.video;
  }
}
